/* eslint-disable import/extensions */
import React, { PureComponent } from 'react';

import { Checkbox, Link, Panel } from '@philips-emr/tws-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { bool, eventListener, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { MessageService } from '@philips-emr/tws-core/lib/services';
import { getLostProps, propagateProps } from '@philips-emr/tws-utils';

import './hpms-terms-of-use.css';
import { HpmsTermsOfUseAPI } from '../../api';

@AwesomeComponent({ type: ComponentType.DATA_ENTRY, api: HpmsTermsOfUseAPI })
class HpmsTermsOfUse extends PureComponent {

  static propTypes = {
    routeTerm: string,
    routeWarning: string,
    onChange: eventListener,
    onClickTerm: eventListener,
    onClickWarning: eventListener,
    enabled: bool,
    value: bool,
    responsabilityTerm: bool,
  }

  getCheckbox() {
    const { value, responsabilityTerm } = this.props;
    const lostProps = getLostProps(HpmsTermsOfUse, this.props);

    if (responsabilityTerm) {
      return propagateProps(<Checkbox value={value} />, { ...this.props, ...lostProps });
    }

    return propagateProps(<Checkbox label="provider.i-agree-with-term" value={value} />, { ...this.props, ...lostProps });
  }

  getLinks() {
    const { onClickTerm, onClickWarning, responsabilityTerm } = this.props;
    if (responsabilityTerm) {
      return (
        <>
          <Link value="provider.i-agree-with-the-terms" onClick={onClickTerm} />
        </>
      );

    }
    return (
      <>
        <Link value="provider.terms-of-service" onClick={onClickTerm} />
        {` ${MessageService.translate('provider.and')} `}
        <Link value="provider.privacy-notice" onClick={onClickWarning} />
      </>
    );
  }
  renderComponents() {
    return (
      <Panel padding = "1rem 0 1rem 0" >
      <div className="c-hpms-term-checkbox__wrapper">
        <div className="c-hpms-term-checkbox__checkbox">
          {this.getCheckbox()}
        </div>
        <div className="c-hpms-term-checkbox__link">
          {this.getLinks()}
        </div>
      </div>
      </Panel>
    );
  }

  render() {
    return this.renderComponents();
  }

}

export {
  HpmsTermsOfUse,
};
